export const IconOptions = {
    blackboard: { type: "norm", value: "blackboard" },
    buildingsCity: { type: "pro", value: "buildings-city" },
    calendar: { type: "norm", value: "calendar" },
    certificate: { type: "pro", value: "certificate" },
    check: { type: "pro", value: "check" },
    chevronLeft: { type: "norm", value: "chevron-left" },
    circleAlert: { type: "pro", value: "circle-alert" },
    circlePlus: { type: "pro", value: "circle-plus" },
    circleCheck: { type: "pro", value: "circle-check" },
    cog: { type: "norm", value: "cog" },
    education: { type: "pro", value: "education" },
    exclamationSign: { type: "pro", value: "triangle-alert" },
    questionSign: { type: "norm", value: "question-sign" },
    factory: { type: "pro", value: "factory" },
    file: { type: "norm", value: "file" },
    folder: { type: "pro", value: "folder" },
    folderOpen: { type: "pro", value: "folder-open" },
    home: { type: "norm", value: "home" },
    infoSign: { type: "pro", value: "circle-info" },
    location: { type: "norm", value: "map-marker" },
    lock: { type: "pro", value: "lock" },
    map: { type: "norm", value: "map-marker" },
    newWindow: { type: "norm", value: "new-window" },
    okSign: { type: "norm", value: "ok-sign" },
    removeSign: { type: "norm", value: "remove-sign" },
    user: { type: "pro", value: "user" },
    users: { type: "pro", value: "user-parents-alt" },
    webcam: { type: "pro", value: "webcam" },
    link: { type: "norm", value: "link" },
    merge: { type: "norm", value: "import" },
    account: { type: "pro", value: "factory" },
    contact: { type: "pro", value: "user" },
    contacts: { type: "pro", value: "user-parents-alt" },
    email: { type: "norm", value: "envelope" },
    trainingPass: { type: "pro", value: "id-badge" },
    squareCheckbox: { type: "pro", value: "square-checkbox" },
    text: { type: "pro", value: "text" },
    paragraphLeft: { type: "pro", value: "paragraph-left" },
    squareTriangleDown: { type: "pro", value: "square-triangle-down" },
    table: { type: "pro", value: "table" },
    tag: { type: "norm", value: "tag" },
    code: { type: "pro", value: "code" },
    idBadge: { type: "pro", value: "id-badge" },
};
